import styled from "styled-components"

export const PaymentContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 0px;
`
